import api from '../utils/api';

const bookService = {
    // جلب كل الكتب
    getBooks: async (filters = {}) => {
        const response = await api.get('/admin/books', { params: filters });
        return response.data;
    },

    // جلب كتاب محدد
    getBook: async (id) => {
        const response = await api.get(`/admin/books/${id}`);
        return response.data;
    },

    // إضافة كتاب جديد
    createBook: async (bookData) => {
        try {
            const response = await api.post('/admin/books', bookData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            // Error Response data
            if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            if (error.response?.data?.errors) {
                const errors = error.response.data.errors;
                const firstError = Object.values(errors)[0][0];
                throw new Error(firstError);
            }
            throw error;
        }
    },

    // تحديث كتاب
    updateBook: async (id, formData) => {
        try {
            const response = await api.post(`/admin/books/${id}?_method=PUT`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            // Error Response data
            if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            if (error.response?.data?.errors) {
                const errors = error.response.data.errors;
                const firstError = Object.values(errors)[0][0];
                throw new Error(firstError);
            }
            throw error;
        }
    },

    // حذف كتاب
    deleteBook: async (id) => {
        await api.delete(`/admin/books/${id}`);
    }
};

export default bookService;
